"use client";

import type { ComponentProps } from "react";
import { ImageUpload } from "../../image-upload/image-upload";
import { useStoreBuilderContext } from "./store-builder-context";

type ImageUploadProps = ComponentProps<typeof ImageUpload>;

export const StoreBuilderUpload = ({
	images,
	fieldPathPrefix = "image.",
	className,
	width,
	height,
	onUpload,
	onDelete,
}: {
	images: string[];
	fieldPathPrefix?: string;
	className?: string;
	width?: number;
	height?: number;
	onUpload?: ImageUploadProps["onUpload"];
	onDelete?: ImageUploadProps["onDelete"];
}) => {
	const context = useStoreBuilderContext();
	return (
		<ImageUpload
			className={className}
			maxImages={1}
			width={width}
			height={height}
			images={images}
			onUpload={(imageUrl, size) => {
				context.saveSelectedPageSectionField({
					fieldPath: fieldPathPrefix + "src",
					value: imageUrl,
				});
				onUpload?.(imageUrl, size);
			}}
			onDelete={(imageUrl) => {
				context.saveSelectedPageSectionField({
					fieldPath: fieldPathPrefix + "src",
					value: null,
				});
				onDelete?.(imageUrl);
			}}
		/>
	);
};
